import { useState } from "react";
import { Step2MessageType, Step2PhoneState } from "../../types/copilot/step2";

type AppendAssistantStep = (type: Step2MessageType | "whatsapp") => void;

const useStep2Flow = () => {
  const [step2State, setStep2State] = useState<Step2PhoneState>("S2_CHOICE");

  const step2TypeForState = (state: Step2PhoneState): Step2MessageType | null => {
    switch (state) {
      case "S2_CHOICE":
        return "whatsapp_choice";
      case "S2_OWN_FORM":
        return "whatsapp_own_form";
      case "S2_OWN_SMS_CODE":
        return "whatsapp_own_sms_code";
      case "S2_OWN_SMS_FAILED":
        return "whatsapp_own_sms_failed";
      case "S2_OWN_WHATSAPP_CHECK":
        return "whatsapp_own_whatsapp_check";
      case "S2_OWN_WHATSAPP_FAILED":
        return "whatsapp_own_whatsapp_failed";
      case "S2_OWN_SUCCESS":
        return "whatsapp_own_success";
      case "S2_VUELVE_PICK":
        return "whatsapp_vuelve_pick";
      default:
        return null;
    }
  };

  const goStep2 = (next: Step2PhoneState, appendAssistantStep: AppendAssistantStep) => {
    setStep2State(next);
    const type = step2TypeForState(next);
    if (type) appendAssistantStep(type);
    if (next === "S2_DONE") appendAssistantStep("whatsapp_meta");
  };

  const isStep2TypeActive = (type: Step2MessageType) => {
    const activeType = step2TypeForState(step2State);
    if (step2State === "S2_DONE") return type === "whatsapp_meta";
    return activeType === type;
  };

  return {
    step2State,
    setStep2State,
    step2TypeForState,
    goStep2,
    isStep2TypeActive,
  };
};

export default useStep2Flow;
